import React, { useEffect, useRef } from 'react'
import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger)

const metiers = [
  {
    num: '01',
    title: 'Hair Couture',
    image: 'https://images.unsplash.com/photo-1562322140-8baeececf3df?q=80&auto=format&fit=crop&w=1200',
    description: 'Precision cuts, editorial styling, colour artistry and restorative treatments — sculpted to the individual.',
  },
  {
    num: '02',
    title: 'Makeup Artistry',
    image: 'https://images.unsplash.com/photo-1487412947147-5cebf100ffc2?q=80&auto=format&fit=crop&w=1200',
    description: 'Bridal, occasion and editorial makeup — luminous, long-wearing, unmistakably you.',
  },
  {
    num: '03',
    title: 'Body & Skin',
    image: 'https://images.unsplash.com/photo-1570172619644-dfd03ed5d881?q=80&auto=format&fit=crop&w=1200',
    description: 'Advanced facials, skin science and body rituals that restore clarity, calm and glow.',
  },
]

export default function Metiers() {
  const ref = useRef<HTMLElement>(null)

  useEffect(() => {
    if (!ref.current) return

    const ctx = gsap.context(() => {
      const cards = ref.current?.querySelectorAll('.metiers__card')
      if (!cards) return

      gsap.fromTo(
        cards,
        { opacity: 0, y: 60 },
        {
          opacity: 1,
          y: 0,
          duration: 1,
          stagger: 0.2,
          ease: 'power3.out',
          scrollTrigger: {
            trigger: ref.current,
            start: 'top 75%',
            once: true,
          },
        }
      )

      // Image hover scale
      cards.forEach((card) => {
        const img = card.querySelector('.metiers__card-image')
        if (!img) return
        card.addEventListener('mouseenter', () => {
          gsap.to(img, { scale: 1.08, duration: 0.6, ease: 'power2.out' })
        })
        card.addEventListener('mouseleave', () => {
          gsap.to(img, { scale: 1, duration: 0.6, ease: 'power2.out' })
        })
      })
    }, ref.current)

    return () => ctx.revert()
  }, [])

  return (
    <section ref={ref} className="metiers" id="services">
      <div className="metiers__header">
        <span className="metiers__label">Our Métiers</span>
        <h2 className="metiers__title">
          Three Disciplines, <em>One Standard</em>
        </h2>
      </div>

      <div className="metiers__grid">
        {metiers.map((m) => (
          <a
            key={m.num}
            href="#reservations"
            className="metiers__card"
          >
            <div className="metiers__card-image">
              <img src={m.image} alt={m.title} />
              <div className="metiers__card-overlay">
                <span className="metiers__card-num">{m.num}</span>
                <span className="metiers__card-arrow">Reserve this ritual →</span>
              </div>
            </div>
            <div className="metiers__card-body">
              <h3 className="metiers__card-title">{m.title}</h3>
              <p className="metiers__card-desc">{m.description}</p>
            </div>
          </a>
        ))}
      </div>
    </section>
  )
}